import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { useLocation, useNavigate } from 'react-router-dom';
import { HttpStatusCode } from 'axios';
import { axiosHttp } from '../../wrapper/AxiosWrapper';
import { localdb } from "../../util/localDbUtil";

const AuthenticationContext = createContext({});
const excluded_redirected_path = ["/dss"]

const AuthenticationProvider = ({ children }) => {
    const [inProgress, setInProgress] = useState(false);

    const navigate = useNavigate();
    const location = useLocation();


    const logedInSuccess = (data, calbackUrl) => {
        calbackUrl = calbackUrl || "/u/forms";
        data.user.loggedOn = Date.now();
        localdb.put("userData", JSON.stringify(data));
        setUserData(data.user);
        navigate(calbackUrl);
    };

    const isLoggedIn = () => {
        let user = localdb.get("userData") && JSON.parse(localdb.get("userData")).user;
        if (!user || !user.loggedOn) {
            return false;
        }
        return true;
    }

    const getUser = () => {
        if (localdb.get("userData")) {
            return JSON.parse(localdb.get("userData")).user;
        }
    }

    const updateUser = (data) => {
        let userData = JSON.parse(localdb.get("userData"));
        if (data.displayName) {
            userData.user.displayName = data.displayName
        }
        localdb.put("userData", JSON.stringify(userData));
        setUserData(userData.user);
    }

    const logout = () => {
        axiosHttp.post("/api/dss/v1/signout")
            .then((res) => {
            }).catch((err) => { })
            .then((res) => {
                clearUser();
               // navigate("/");
            })
    };

    const clearUser = () => {
        localdb.remove("userData");
        setUserData(null);
    }

    const [userData, setUserData] = useState(getUser());

    const memoObj = useMemo(() => ({logedInSuccess, logout, isLoggedIn, getUser, userData, updateUser }),
        [userData, isLoggedIn]);
    return (
        <AuthenticationContext.Provider value={memoObj}>
            {children}
        </AuthenticationContext.Provider>
    )
}

const useAuthentication = () => {
    return useContext(AuthenticationContext);
}

export { AuthenticationProvider, useAuthentication };

const setRedirectPath = (redirectPath) => {
    let pathArr = excluded_redirected_path.filter(path => redirectPath.startsWith(path));
    if (!pathArr || pathArr.length === 0) {
        localdb.put("redirectPath", redirectPath);
    }

}

const getRedirectPath = (path) => {
    return localdb.get("redirectPath");
}

const handleResponseErrors = (openLoginModal, navigate) => {
    const responseInterceptor = axiosHttp.interceptors.response.use(response => {
        return response

    }, (error) => {
        if (error.status === 401) {//authentication
            openLoginModal();
        } else if (error.status === 403) {//Forbidden force logout
            navigate("/error/inactive");
        } else if (error.status === 404) {//No Found
        } else if ("ERR_NETWORK" === error.code) {
        } else if (error.response && error.response.status === 503) {//Service unavailable
            //underMaintenanceModal();
        } else {
            // toggleError(true, error);// all other internal errors
            //errorModal();
        }
        return Promise.reject(error)
    })

    return () => {
        axiosHttp.interceptors.response.eject(responseInterceptor);
    }
}

